import { useNavigate, useLocation } from "react-router";
import { useCallback } from "react";

/**
 * Reload the page using react-router (without a full-page reload).
 * This will re-render everything but the navbar.
 */
export function useReload() {
  const navigate = useNavigate();
  const { pathname, search, hash } = useLocation();
  return useCallback(
    () =>
      navigate(
        `${pathname}${search}${hash}`,
        // empty the location state (which stores error info)
        { replace: true, state: {} }
      ),
    [navigate, pathname, search, hash]
  );
}
